export default "__VITE_ASSET__DtwySg95__"